import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '../ui/sidebar'
import { NavGroup } from './nav-group'
import { NavUser } from './nav-user'
// import { TeamSwitcher } from './team-switcher'
import { sidebarData } from '../../data/sidebar.data'
import { useAuthStore } from '@/stores/auth'
import { UserRole } from '@/constants/user'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const user = useAuthStore(state => state.user);
  
  // Filter sidebar items based on user role
  const filteredNavGroups = sidebarData.navGroups.map(group => ({
    ...group,
    items: group.items.filter(item => {
      if (user?.role === UserRole.MANAGER) {
        const managerAllowedPaths = ['/s3-file', '/tracking-time', '/setting/list-setting'];
        return managerAllowedPaths.includes(item.url as string);
      }
      return true;
    })
  }));

  return (
    <Sidebar collapsible='icon' variant='floating' {...props} className='bg-white'>
      <SidebarHeader className='bg-white'>
        {/* <TeamSwitcher teams={sidebarData.teams} /> */}
        <NavUser user={{
          email: user?.email || 'luxtech@global.com',
          name: user?.name || 'luxtech',
          avatar: sidebarData.user.avatar
        }} />

      </SidebarHeader>
      <SidebarContent className='bg-white'>
        {filteredNavGroups.map((props) => (
          <NavGroup key={props.title} {...props} />
        ))}
      </SidebarContent>
      <SidebarFooter className='bg-white'>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
